import axios from 'axios';
import config from 'config';

const http = axios.create({
    baseURL: `${config.BASE_URL}/api`,
});

export default http;
